import { __commonJSMin as e } from "../../../../../_virtual/_rolldown/runtime.js";
//#region ../../node_modules/.pnpm/lodash.toarray@4.4.0/node_modules/lodash.toarray/index.js
var t = /* @__PURE__ */ e(((e, t) => {
	var n = 9007199254740991, r = "[object Arguments]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Map]", ee = "[object Object]", s = "[object Promise]", c = "[object Set]", te = "[object String]", l = "[object WeakMap]", u = "[object DataView]", d = /[\\^$.*+?()[\]{}|]/g, ne = /^\[object .+?Constructor\]$/, re = /^(?:0|[1-9]\d*)$/, f = "\\ud800-\\udfff", p = "\\u0300-\\u036f\\ufe20-\\ufe23", m = "\\u20d0-\\u20f0", h = "\\ufe0e\\ufe0f", ie = "[" + f + "]", g = "[" + p + m + "]", _ = "\\ud83c[\\udffb-\\udfff]", ae = "(?:" + g + "|" + _ + ")", v = "[^" + f + "]", y = "(?:\\ud83c[\\udde6-\\uddff]){2}", b = "[\\ud800-\\udbff][\\udc00-\\udfff]", x = "\\u200d", S = ae + "?", C = "[" + h + "]?", oe = "(?:" + x + "(?:" + [
		v,
		y,
		b
	].join("|") + ")" + C + S + ")*", w = C + S + oe, T = "(?:" + [
		v + g + "?",
		g,
		y,
		b,
		ie
	].join("|") + ")", se = RegExp(_ + "(?=" + _ + ")|" + T + w, "g"), ce = RegExp("[" + x + f + p + m + h + "]"), le = typeof global == "object" && global && global.Object === Object && global, ue = typeof self == "object" && self && self.Object === Object && self, E = le || ue || Function("return this")();
	function de(e, t) {
		for (var n = -1, r = e ? e.length : 0, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
		return i;
	}
	function fe(e) {
		return e.split("");
	}
	function pe(e, t) {
		for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
		return r;
	}
	function me(e, t) {
		return de(t, function(t) {
			return e[t];
		});
	}
	function he(e, t) {
		return e?.[t];
	}
	function ge(e) {
		return ce.test(e);
	}
	function _e(e) {
		var t = !1;
		if (e != null && typeof e.toString != "function") try {
			t = !!(e + "");
		} catch {}
		return t;
	}
	function ve(e) {
		for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
		return n;
	}
	function ye(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e, r) {
			n[++t] = [r, e];
		}), n;
	}
	function D(e, t) {
		return function(n) {
			return e(t(n));
		};
	}
	function O(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e) {
			n[++t] = e;
		}), n;
	}
	function k(e) {
		return ge(e) ? A(e) : fe(e);
	}
	function A(e) {
		return e.match(se) || [];
	}
	var j = Function.prototype, M = Object.prototype, N = E["__core-js_shared__"], P = function() {
		var e = /[^.]+$/.exec(N && N.keys && N.keys.IE_PROTO || "");
		return e ? "Symbol(src)_1." + e : "";
	}(), F = j.toString, I = M.hasOwnProperty, L = M.toString, be = RegExp("^" + F.call(I).replace(d, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), R = E.Symbol, z = R ? R.iterator : void 0, xe = M.propertyIsEnumerable, Se = D(Object.keys, Object), B = K(E, "DataView"), V = K(E, "Map"), H = K(E, "Promise"), U = K(E, "Set"), W = K(E, "WeakMap"), Ce = J(B), G = J(V), we = J(H), Te = J(U), Ee = J(W);
	function De(e, t) {
		var n = Y(e) || Fe(e) ? pe(e.length, String) : [], r = n.length, i = !!r;
		for (var a in e) (t || I.call(e, a)) && !(i && (a == "length" || Me(a, r))) && n.push(a);
		return n;
	}
	function Oe(e) {
		return L.call(e);
	}
	function ke(e) {
		return !Q(e) || Ne(e) ? !1 : (Z(e) || _e(e) ? be : ne).test(J(e));
	}
	function Ae(e) {
		if (!Pe(e)) return Se(e);
		var t = [];
		for (var n in Object(e)) I.call(e, n) && n != "constructor" && t.push(n);
		return t;
	}
	function je(e, t) {
		var n = -1, r = e.length;
		for (t ||= Array(r); ++n < r;) t[n] = e[n];
		return t;
	}
	function K(e, t) {
		var n = he(e, t);
		return ke(n) ? n : void 0;
	}
	var q = Oe;
	(B && q(new B(/* @__PURE__ */ new ArrayBuffer(1))) != u || V && q(new V()) != o || H && q(H.resolve()) != s || U && q(new U()) != c || W && q(new W()) != l) && (q = function(e) {
		var t = L.call(e), n = t == ee ? e.constructor : void 0, r = n ? J(n) : void 0;
		if (r) switch (r) {
			case Ce: return u;
			case G: return o;
			case we: return s;
			case Te: return c;
			case Ee: return l;
		}
		return t;
	});
	function Me(e, t) {
		return t ??= n, !!t && (typeof e == "number" || re.test(e)) && e > -1 && e % 1 == 0 && e < t;
	}
	function Ne(e) {
		return !!P && P in e;
	}
	function Pe(e) {
		var t = e && e.constructor;
		return e === (typeof t == "function" && t.prototype || M);
	}
	function J(e) {
		if (e != null) {
			try {
				return F.call(e);
			} catch {}
			try {
				return e + "";
			} catch {}
		}
		return "";
	}
	function Fe(e) {
		return Ie(e) && I.call(e, "callee") && (!xe.call(e, "callee") || L.call(e) == r);
	}
	var Y = Array.isArray;
	function X(e) {
		return e != null && Le(e.length) && !Z(e);
	}
	function Ie(e) {
		return $(e) && X(e);
	}
	function Z(e) {
		var t = Q(e) ? L.call(e) : "";
		return t == i || t == a;
	}
	function Le(e) {
		return typeof e == "number" && e > -1 && e % 1 == 0 && e <= n;
	}
	function Q(e) {
		var t = typeof e;
		return !!e && (t == "object" || t == "function");
	}
	function $(e) {
		return !!e && typeof e == "object";
	}
	function Re(e) {
		return typeof e == "string" || !Y(e) && $(e) && L.call(e) == te;
	}
	function ze(e) {
		if (!e) return [];
		if (X(e)) return Re(e) ? k(e) : je(e);
		if (z && e[z]) return ve(e[z]());
		var t = q(e);
		return (t == o ? ye : t == c ? O : Ve)(e);
	}
	function Be(e) {
		return X(e) ? De(e) : Ae(e);
	}
	function Ve(e) {
		return e ? me(e, Be(e)) : [];
	}
	t.exports = ze;
}));
//#endregion
export default t();
export { t as require_lodash_toarray };
